import { SearchInput } from "@components/ui/SearchInput";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@components/shadcn-ui/select";
import { TaskStatus } from "../types";

interface TaskToolsProps {
    searchQuery: string;
    handleSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    selectedStatus: TaskStatus | null;
    handleStatusChange: (status: TaskStatus | "all") => void;
}

export const TaskTools = ({
                              searchQuery,
                              handleSearchChange,
                              selectedStatus,
                              handleStatusChange,
                          }: TaskToolsProps) => (
    <div className="flex flex-wrap items-center gap-1 px-0">
        <SearchInput
            searchQuery={searchQuery}
            handleSearchChange={handleSearchChange}
            messages={[
                "Search tasks quickly...",
                "by title...",
                "Or by status...",
                "Or by task id...",
                "Or by assignee..",
                "Or by author..",
                "Or by applicationId..",
                "Or by task type.."
            ]}
        />
        <div className="h-12 w-full md:w-64">
            <Select
                value={selectedStatus || "all"}
                onValueChange={(value) =>
                    handleStatusChange(value as TaskStatus | "all")
                }
            >
                <SelectTrigger className="bg-white w-full min-h-full md:w-64 text-muted-foreground">
                    <SelectValue placeholder="Filter by status" />
                </SelectTrigger>
                <SelectContent>
                    <SelectItem value="all">All Statuses</SelectItem>
                    {Object.values(TaskStatus).map((status) => (
                        <SelectItem key={status} value={status}>
                            {status.replace('_', ' ')}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    </div>
);